export const getDiscountPrice = (price, discount) => {
  return price - price * (discount / 100);
};
